import { TransactionInstruction, PublicKey, AccountMeta } from "@solana/web3.js" // eslint-disable-line @typescript-eslint/no-unused-vars
import BN from "bn.js" // eslint-disable-line @typescript-eslint/no-unused-vars
import * as borsh from "@coral-xyz/borsh" // eslint-disable-line @typescript-eslint/no-unused-vars
import * as types from "../types" // eslint-disable-line @typescript-eslint/no-unused-vars
import { PROGRAM_ID } from "../programId"

export interface CreateTreeArgs {
  maxDepth: number
  maxBufferSize: number
  public: boolean | null
}

export interface CreateTreeAccounts {
  treeAuthority: PublicKey
  merkleTree: PublicKey
  payer: PublicKey
  treeCreator: PublicKey
  logWrapper: PublicKey
  compressionProgram: PublicKey
  systemProgram: PublicKey
}

export const layout = borsh.struct([
  borsh.u32("maxDepth"),
  borsh.u32("maxBufferSize"),
  borsh.option(borsh.bool(), "public"),
])

/** Creates a new tree. */
export function createTree(
  args: CreateTreeArgs,
  accounts: CreateTreeAccounts,
  programId: PublicKey = PROGRAM_ID
) {
  const keys: Array<AccountMeta> = [
    { pubkey: accounts.treeAuthority, isSigner: false, isWritable: true },
    { pubkey: accounts.merkleTree, isSigner: false, isWritable: true },
    { pubkey: accounts.payer, isSigner: true, isWritable: true },
    { pubkey: accounts.treeCreator, isSigner: true, isWritable: false },
    { pubkey: accounts.logWrapper, isSigner: false, isWritable: false },
    { pubkey: accounts.compressionProgram, isSigner: false, isWritable: false },
    { pubkey: accounts.systemProgram, isSigner: false, isWritable: false },
  ]
  const identifier = Buffer.from([165, 83, 136, 142, 89, 202, 47, 220])
  const buffer = Buffer.alloc(1000)
  const len = layout.encode(
    {
      maxDepth: args.maxDepth,
      maxBufferSize: args.maxBufferSize,
      public: args.public,
    },
    buffer
  )
  const data = Buffer.concat([identifier, buffer]).slice(0, 8 + len)
  const ix = new TransactionInstruction({ keys, programId, data })
  return ix
}
